import { useState, useEffect, useCallback } from 'react'
import { retrieveProducts } from './dataRetrieval'

function ModelSearch() {
  const [listData, setListData] = useState([])

  // loading data
  useEffect(() => {
    let ignore = false
    ;(async () => {
      try {
        const data = await retrieveProducts()
        const records = Array.isArray(data) ? data : (data?.records ?? [])
        if (!ignore) setListData(records)
      } catch (e) {
        if (!ignore) console.log(`❌ Could'nt fetch data from Airtable...`)
      }
    })()
    return () => {
      ignore = true
    }
  }, [])

  if (!listData.length) {
    return <div className="loading-screen">Waiting for API...</div>
  }

  return (
    <div className="search-wrap">
      <h1>SKU&apos;s</h1>
      <ul>
        {listData.map((item) => {
          return (
            <li key={item?.fields['Commercial Item']}>
              <a href={`/model/${item?.fields['Commercial Item']}`}>
                {item?.fields['Commercial Item']}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default ModelSearch
